module.exports = __webpack_public_path__ + "static/media/preview_chart_1_Bookings.5c2db54d.PNG";